import React, { useRef, useState } from 'react';
import { DraggableCore } from 'react-draggable';
import styled from 'styled-components';

const Container = styled.div<{ placement: 'left' | 'right' }>`
  height: 100%;
  width: 30px;
  position: absolute;
  ${(props) => (props.placement === 'right' ? 'right' : 'left')}: -15px;
  pointer-events: auto;
  display: flex;
  justify-content: center;
  z-index: 1;
`;

const Handle = styled.div<{ isResizing: boolean }>`
  width: 4px;
  background-color: var(--background-invert);
  cursor: ew-resize;
  opacity: ${(props) => (props.isResizing ? 0.2 : 0)};
  transition: all 0.2s;
  border-radius: 4px;

  ${Container}:hover & {
    opacity: 0.2;
  }
`;

interface ResizeHandleProps {
  placement: 'left' | 'right'
  onResizeStart: () => void
  onResizeStop: () => void
  onResize: (deltaX: number) => void
}

export function ResizeHandle(props: ResizeHandleProps) {
  const {
    placement, onResizeStart, onResizeStop, onResize,
  } = props;

  const [isResizing, setIsResizing] = useState(false);
  const lastX = useRef(0);

  return (
    <DraggableCore
      onStart={(event) => {
        lastX.current = (event as React.MouseEvent).clientX;
        setIsResizing(true);
        onResizeStart?.();
      }}
      onDrag={(event) => {
        const { clientX } = event as React.MouseEvent;
        const deltaX = clientX - lastX.current;
        if (deltaX !== 0) {
          onResize(deltaX);
        }
        lastX.current = clientX;
      }}
      onStop={() => {
        setIsResizing(false);
        onResizeStop?.();
      }}
    >
      <Container placement={placement}>
        <Handle isResizing={isResizing} />
      </Container>
    </DraggableCore>
  );
}
